import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import pdfMake from 'pdfmake'
import 'datatables.net-buttons/js/buttons.html5'
import store from '@/store'
import lang from '@/plugins/lang'
import { nowFormat } from '@/helpers/dateHelper'

/**
 * @typedef TotalsTable
 * @property {string[]} header
 * @property {string[]} [footer]
 * @property {string[][]} body
 */

pdfMake.vfs = pdfFonts.pdfMake.vfs

pdfMake.tableLayouts = {
    customLayout: {
        hLineWidth() {
            return 0;
        },

        vLineWidth() {
            return 0;
        },

        paddingLeft(col) {
            return col === 0 ? 8 : 4;
        },

        paddingRight(col, node) {
            return (col === node.table.widths.length - 1) ? 8 : 4;
        },
        paddingTop() {
            return 6;
        },
        paddingBottom() {
            return 6;
        },
    },
}

const colorPrimary = '7D4FC2'

let logoApp = null

const actionPdfOriginal = $.fn.dataTable.ext.buttons.pdfHtml5.action

/**
 * @param {string} url
 * @return {Promise<unknown>}
 */
function toDataUrl(url) {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = function() {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.height = this.height
            canvas.width = this.width
            ctx.drawImage(this, 0, 0)

            resolve(canvas.toDataURL())
        }

        img.onerror = (error) => reject(url)

        // É necessário pegar a imagem direto, sem ser do cache, por conta do crossOrigin
        img.src = url + '?not-from-cache'
    })
}

async function loadLogoApp() {
    if (!logoApp) {
        logoApp = await toDataUrl(store().logo_dark)
    }

    return logoApp
}

$.extend($.fn.dataTable.ext.buttons, {
    customPdf: {
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'A2',
        activeFilters: () => ({}),

        /**
         * @return {TotalsTable|null}
         */
        totalsTable: () => null,

        action( e, dt, button, config ) {
            this.processing( true )

            config.exportOptions.columns = dt.columns().visible().toArray().reduce((acc, v, idx) => {
                if(v) {
                    acc.push(idx)
                }
                return acc
            }, [])

            loadLogoApp().finally(() => actionPdfOriginal.call(this, e, dt, button, config))
        },
        customize( doc, dtConfig ) {
            doc.info = {
                title: dtConfig.filename === '*' ? document.title : dtConfig.fileName
            }

            if (logoApp) {
                doc.content.splice( 0, 0, {
                    margin: [ 0, 0, 0, 12 ],
                    alignment: 'center',
                    width: 150,
                    image: logoApp,
                } );
            }

            let tableContent = doc.content.splice(2, 1)[0]

            doc.content.push({
                columns: [
                    {
                        width: 'auto',
                        bold: true,
                        text: lang.t('created_at') + ': ',
                    },
                    {
                        width: 'auto',
                        text: nowFormat(),
                        margin: [4,0,8,0]
                    },
                    {
                        width: 'auto',
                        bold: true,
                        text: lang.t('user') + ': ',
                    },
                    {
                        width: 'auto',
                        text: store().auth.name,
                        margin: [4,0,8,0]
                    }
                ],
            })

            doc.content.push({
                text: lang.t('filters'), bold: true, fontSize: 13, margin: [0,12,0,4]
            })

            Object.values(dtConfig.activeFilters()).forEach(item => {
                let columns = []

                item.forEach(filter => {
                    columns.push({
                        width: 'auto',
                        bold: true,
                        text: filter.input + ':',
                        noWrap: true
                    })

                    columns.push({
                        width: 'auto',
                        text: (filter.value || lang.t('no_filter')) + ';',
                        margin: [4,0,8,0]
                    })
                })

                doc.content.push({ columns, margin: [0,0,0,4] })
            })

            const totals = dtConfig.totalsTable()

            if (totals) {
                doc.content.push({
                    text: lang.t('report:totals'), bold: true, fontSize: 13, margin: [0,12,0,4]
                })

                const body = [
                    totals.header.map(text => ({ text, style: 'tableHeader' })),
                    ...totals.body.map((row, idx) => row.map((text) => ({ text, style: idx % 2 ? 'tableBodyOdd' : 'tableBodyEven' })))
                ]

                if (totals.footer) {
                    body.push(totals.footer.map(text => ({ text, style: 'tableFooter' })))
                }

                doc.content.push({
                    width: 'auto',
                    layout: 'customLayout',
                    headerRows: 1,
                    table: { body }
                })
            }

            tableContent.width = 'auto'

            tableContent.layout = 'customLayout'

            // Centraliza a  table
            doc.content.push({
                margin: [0, 20, 0, 0],
                columns: [
                    { width: '*', text: '' },
                    tableContent,
                    { width: '*', text: '' },
                ]
            })

            doc.styles.tableFooter.fillColor = '#' + colorPrimary

            doc.styles.tableHeader.fillColor = '#' + colorPrimary

            doc.styles.tableHeader.alignment = 'left'

            doc.styles.title.bold = true
        }
    }
})
